import {Resource} from "../resources/resource";
import { client } from "clientInstance";

export function uploadLogo<T extends Resource>(resource: T, logo: File) {
    const fd = new FormData();
    fd.append("fileToUpload", logo);
    return client.post(resource.Links["Logo"], fd);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/logoUpload.ts